import { render, staticRenderFns } from "./TableColumn.vue?vue&type=template&id=705d5448&"
import script from "./TableColumn.vue?vue&type=script&lang=ts&"
export * from "./TableColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports